import React from "react";
import throttle from "lodash/throttle";
import { Button } from "@sainsburys-tech/fable";

export default class extends React.Component {
  state = {
    showButton: false
  };

  componentDidMount() {
    window.addEventListener("scroll", throttle(this.handleScroll, 1000));
  }

  handleScroll = () => {
    const scrollVal = document.documentElement.scrollTop;
    this.setState({ showButton: scrollVal > 1 });
  };

  handleClick = e => {
    e.preventDefault();
    window.scrollTo(0, 0);
  };

  render() {
    return (
      this.state.showButton && (
        <Button
          variant="primary"
          id="backToTopBtn"
          onClick={this.handleClick}
          className="fable:px-6 fable:py-2 cb-c-back-to-top-button">
          Back to top
        </Button>
      )
    );
  }
}
